import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { showToast, ToastMessage } from '../../Shared/ToastMessage';
import { baseUrl } from '../../../api/common';
import { FormCheck } from "react-bootstrap";
import "react-phone-number-input/style.css";

const AdminUserRoleAdd = ({ fetchRoleTypeData, addPopupStatus, handleAddPopup, eventType, updateData }) => {

  const [updateId, setUpdateId] = useState("");
  const [moduleId, setModuleId] = useState([]);
  
  const [formValues, setFormValues] = useState({
    role_name: ""
  });

  const [errors, setErrors] = useState({
    role_name: ""
  });

  useEffect(() => {
    if (eventType === "Update" && updateData) {
      setUpdateId(updateData.id);
      setFormValues({
        role_name: updateData.role_name || ''
      });
    } else {
      setErrors({
        role_name: ""
      });
      setFormValues({
        role_name: ""
      });
    }
    fetchModuleData();
  }, [eventType, updateData, addPopupStatus]);

  const handleInputChange = (field, value) => {
    setFormValues({ ...formValues, [field]: value });
  };

  const validate = () => {
    const newErrors = {
      role_name: ""
    };
    if (!formValues.role_name.trim()) {
      newErrors.role_name = 'Role Type name cannot be empty';
    }
    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === '');
  };

  const clearInputValues = () => {
    setErrors({
      role_name: ""
    });
    setFormValues({
      role_name: ""
    });
    setModuleCheckedValues({});
    handleAddPopup(false);
  };

  const [moduleCheckedValues, setModuleCheckedValues] = useState({});

  const [moduleData, setModuleData] = useState([]);
  const fetchModuleData = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/api/get_module`,   
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: localStorage.getItem('access_token'),
            },
          }
        );  
        if (response.data.status) {          
          setModuleData(response.data.data);
          setModuleCheckedValues((prevState) => {
            const newState = { ...prevState };
            response.data.data.forEach((module) => {
              if (!newState[module.id]) {
                newState[module.id] = {
                  permission_view: 0,
                  permission_create: 0,
                  permission_update: 0,
                  permission_delete: 0,
                };
              }
            });
            return newState;
          });
          if(eventType==="Update"&&updateData){
            try {
              const response = await axios.post(
                `${baseUrl}/api/role_details`,
                {id:updateData.id},   
                {
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: localStorage.getItem('access_token'),
                  },
                }
              );        
              if (response.data.status) {
                if(response.data.other_data.length>0){
                  const moduleIds=[];
                  response.data.other_data.map((item)=>{
                    moduleIds.push(item.id);
                    handleUpdateCheckboxChange(parseInt(item.module),"permission_view",item.permission_view);
                    handleUpdateCheckboxChange(parseInt(item.module),"permission_create",item.permission_create);
                    handleUpdateCheckboxChange(parseInt(item.module),"permission_update",item.permission_update);
                    handleUpdateCheckboxChange(parseInt(item.module),"permission_delete",item.permission_delete);
                  });
                  setModuleId(moduleIds);      
                }                
              } else {
                console.error('Error: Failed to fetch user data');
              }
            } catch (error) {
              console.error('Error fetching users data:', error);
            }
          }
        } else {
          console.error('Error: Failed to fetch user data');
        }

      } catch (error) {
        console.error('Error fetching users data:', error);
      }
  };

  // useEffect(() => {
  //   if (moduleData.length > 0) {
  //     setModuleCheckedValues((prevState) => {
  //       const newState = { ...prevState };
  //       moduleData.forEach((module) => {
  //         if (!newState[module.id]) {
  //           newState[module.id] = {
  //             permission_view: 0,
  //             permission_create: 0,
  //             permission_update: 0,
  //             permission_delete: 0,
  //           };
  //         }
  //       });
  //       return newState;
  //     });
  //   }
  // }, [moduleData]);

  const handleCheckboxChange = (moduleId, type) => {
    setModuleCheckedValues((prevState) => ({
      ...prevState,
      [moduleId]: {
        ...prevState[moduleId],
        [type]: prevState[moduleId][type] === 1 ? 0 : 1,
      },
    }));
  };

  const handleUpdateCheckboxChange = (moduleId,type,typeValue) => {
    setModuleCheckedValues((prevState) => ({
      ...prevState,
      [moduleId]: {
        ...prevState[moduleId],
        [type]:typeValue,
      },
    }));
  };

  const splitPermissions = (data) => {

    // const result = {
    //   permission_view: [],
    //   permission_create: [],
    //   permission_update: [],
    //   permission_delete: []
    // };

    // Object.entries(data).forEach(([moduleId, permissions]) => {
    //   if (permissions.permission_view === 1) 
    //     result.permission_view.push(Number(moduleId)); else result.permission_view.push(0);
    //   if (permissions.permission_create === 1) 
    //     result.permission_create.push(Number(moduleId)); else result.permission_create.push(0);
    //   if (permissions.permission_update === 1) 
    //     result.permission_update.push(Number(moduleId)); else result.permission_update.push(0);
    //   if (permissions.permission_delete === 1) 
    //     result.permission_delete.push(Number(moduleId)); else result.permission_delete.push(0);
    // });

    const module=[];
    const permission_view=[];
    const permission_create=[];
    const permission_update=[];
    const permission_delete=[];
  
    Object.entries(data).forEach(([moduleId, permissions]) => {
      module.push(moduleId);
      if (permissions.permission_view === 1) 
        permission_view.push(1); else permission_view.push(0);
      if (permissions.permission_create === 1) 
        permission_create.push(1); else permission_create.push(0);
      if (permissions.permission_update === 1) 
        permission_update.push(1); else permission_update.push(0);
      if (permissions.permission_delete === 1) 
        permission_delete.push(1); else permission_delete.push(0);
    });
  
    return {
      module,
      permission_view,
      permission_create,
      permission_update,
      permission_delete
    };
  };

  const addUpdateAdminUserRole = async () => {   
    if (validate()) {
      console.log('Post Data:', formValues);   
      try {
        const requestData = {
          ...formValues,
          ...{login_user_id:localStorage.getItem('loginUserId')},
          ...splitPermissions(moduleCheckedValues),
          ...(eventType === "Update" && 
            { 
              id: updateId,
              permission_id:moduleId
            }),
        };
        console.log("Update requestData Data:", requestData);
        const response = await axios.post(
          `${baseUrl}/api/add_role`,
          requestData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: localStorage.getItem('access_token'),
            },
          }
        );
        if (response.data.status) {
          showToast(response.data.message, 'success');
          fetchRoleTypeData();
          clearInputValues();
        } else {
          showToast(response.data.message, 'error');
        }
      } catch (error) {
        console.error("Error during submission:", error);
        showToast("Submission failed. Please try again.", "error");
      }
    }
  };

  return (
    <>
      <ToastMessage />
      {addPopupStatus && (
        <div className="extraspace_search_div search_div open">
          <div className="card member_master_sidebar_scrool">
            <div className="member_edit_pop_flex mb-3 text-end">
              <h3>{eventType} Role Type</h3>
              <div className="input-group-append">
                <span onClick={() => clearInputValues()} className="search_toggle btn btn-danger"><i className="fa fa-times"></i></span>
              </div>
            </div>
            <div className="table-responsive">
              <div className="body  application_body_side">
                <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Role Type Name *</label>
                        <input
                          type="text"
                          className={`form-control ${errors.role_name ? "red_border" : ''}`}
                          value={formValues.role_name}
                          onChange={(e) => handleInputChange('role_name', e.target.value)}
                   
                        />
                        {errors && (
                          <p className="text-danger pos_abos">{errors.role_name}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12 check_box_mar0">
                        <div className="row">
                          <div className="col-md-4">
                            <p>Module Name</p>
                          </div>
                          <div className="col-2 text-center">
                            <p>View</p>
                          </div>
                          <div className="col-2 text-center">
                            <p>Create</p>
                          </div>
                          <div className="col-2 text-center">
                            <p>Update</p>
                          </div>
                          <div className="col-2 text-center">
                            <p>Delete</p>
                          </div>
                        </div>
                        {moduleData.length > 0 &&
                          moduleData.map((data) => (
                            <div className="row" key={data.id}>
                              <div className="col-md-4">
                                <p>{data.module_name}</p>
                              </div>
                              {["permission_view", "permission_create", "permission_update", "permission_delete"].map((type, index) => (
                                <div className="col-2 text-center" key={index}>
                                  <label>
                                    <FormCheck
                                    className='add-checkbox-custom'
                                      type="checkbox"
                                      id={`checkbox-${data.id}-${type}`}
                                      checked={moduleCheckedValues[data.id]?.[type] === 1}
                                      onChange={() => handleCheckboxChange(data.id, type)}
                                    />
                                    <span />
                                  </label>
                                </div>
                              ))}
                            </div>
                          ))}
                        {/* <pre>{JSON.stringify(moduleCheckedValues, null, 2)}</pre>  */}
                      </div>
                    <div className="col-md-12 p-3">
                      <div className='member_button_flex'>
                        <button onClick={() => addUpdateAdminUserRole()} className="btn btn-outline-info">{eventType}</button>
                        <a onClick={() => clearInputValues()} className="btn btn-outline-danger">Close</a>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AdminUserRoleAdd;